<!-- 楽天用ので現在使われていないため修正しません -->
<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col :cols="isMobile ? 12 : 10">
        <v-breadcrumbs :items="breadcrumbs" class="px-0 pt-0">
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col class="text-right" :cols="isMobile ? 12 : 2">
        <v-btn color="light-blue darken-1 text-white" @click="clickCreativeReport()"
        >{{$t('cpmCreativeReport.buttonToCreativeReport')}}</v-btn>
      </v-col>
      <v-col :cols="isMobile ? 12 : 10">
        <h1 class="mb-3" :class="{ 'text-h6': isMobile, 'text-h5': !isMobile }">{{ $t('campaignReport.title') }}</h1>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12" offset v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="12" id="top-table">
        <div class="mb-2" :class="{ title: !isMobile, subheading: isMobile }" :v-html="$t('campaignReport.info.title')"></div>
        <v-data-table
          :headers="infoHeaders"
          :items="infoResult"
          :hide-default-header="isMobile"
          hide-default-footer
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3"
          :class="{ mobile: isMobile }"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-center">{{ props.item.advertiser.advertiserName }}</td>
              <td class="text-center">{{ props.item.campaign.campaignName }}</td>
              <td class="text-center">{{ props.item.campaign.cpxreportType }}</td>
            </tr>
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item word-break" :data-label="$t('campaignReport.info.headers.advertiserName')">{{ props.item.advertiser.advertiserName }}</li>
                  <li class="flex-item word-break" :data-label="$t('campaignReport.info.headers.campaignName')">{{ props.item.campaign.campaignName }}</li>
                  <li class="flex-item2" :data-label="$t('campaignReport.info.headers.cpxreportType')">{{ props.item.campaign.cpxreportType }}</li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col style="max-width:220px">
      <div>
        <span class="v-label v-label--active theme--light text-center" style="left: 0px; right: auto">
          {{ $t('commons.filter.calendar.title.aggregateDateRange') }}
        </span>
        <br />
        <VueDatePicker
          ref="picker"
          :opens="opens"
          :locale-data="{
            direction: 'ltr',
            format: 'yyyy/mm/dd',
            separator: ' - ',
            weekLabel: '',
            customRangeLabel: 'Custom Range',
            daysOfWeek: $t('commons.filter.calendar.daysOfWeek'),
            firstDay: 1
          }"
          :ranges="ranges"
          :singleDatePicker="false"
          :showWeekNumbers="true"
          v-model="dateRange"
          :linkedCalendars="false"
          :minDate="minDate" :maxDate="maxDate"
          :showDropdowns="false"
          :autoApply="false"
        >
          <!--    input slot (new slot syntax)-->
          <template #input="picker" style="min-width: 350px">
            {{ formatDisplayDate(picker.startDate) }} - {{ formatDisplayDate(picker.endDate) }}
          </template>
          <!--    ranges (new slot syntax) -->
          <template #ranges="ranges">
            <div class="ranges" style="float: left">
              <ul>
                <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                  <b>{{ name }}</b>
                </li>
              </ul>
            </div>
          </template>
          <!--    footer slot-->
          <div slot="footer" slot-scope="data" class="slot">
            <div></div>
            <div style="margin-left: auto">
              <v-btn color="light-green darken-1 text-white" @click="data.clickApply" v-if="!data.in_selection">{{ $t('commons.global.button.select') }}</v-btn>
              <v-btn color="darken-1" @click="data.clickCancel" v-if="!data.in_selection">{{ $t('commons.global.button.cancel') }}</v-btn>
            </div>
          </div>
        </VueDatePicker>
      </div>
    </v-col>
    <v-col md1 xs12 class="text-left mt-auto" offset>
        <v-btn color="blue-grey darken-4 text-white" @click="search()" :disabled="isDisabledBtn">{{ $t('commons.global.button.search') }}</v-btn>
    </v-col>
    </v-row>
    <v-row justify-left class="mt-3">
      <v-col xs12>
        <div class="mb-2" :class="{ title: !isMobile, subheading: isMobile }" :v-html="$t('campaignReport.total.title')">{{ $t('campaignReport.total.title') }}</div>
        <v-data-table
          :headers="totalHeaders"
          :items="infoTotalReport"
          :hide-default-header="isMobile"
          hide-default-footer
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3 totalTable"
          :class="{ mobile: isMobile }"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-center">{{ aggregateDateRange }}</td>
              <td class="text-right">{{ number_format(props.item.imp) }}</td>
              <td class="text-right">{{ props.item.cpm | number_format_yen_fixed_decimal }}</td>
              <td class="text-right">{{ number_format(props.item.click) }}</td>
              <td class="text-right">{{ props.item.cpc | number_format_yen_fixed_decimal }}</td>
              <td class="text-right">{{ props.item.ctr | percent_format_cpm }}</td>
              <td class="text-right">{{ props.item.digestiveAmount | digestive_format }}</td>
              <td class="text-right">{{ number_format(props.item.cv) }}</td>
              <td class="text-right">{{ props.item.cpa | number_format_yen_fixed_decimal }}</td>
              <td class="text-right">{{ props.item.cvr | percent_format_cpm }}</td>
              <td class="text-right">{{ props.item.vcv | number_format }}</td>
              <!-- not VideoAds -->
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <!-- is VideoAds -->
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.playCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.firstQuartileCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.midpointCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.thirdQuartileCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.completeCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</td>
            </tr>
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item word-break" :data-label="$t('campaignReport.total.headers.aggregateDateRange')">{{ aggregateDateRange }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.total.headers.imp')">{{ number_format(props.item.imp) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.total.headers.cpm')">{{ props.item.cpm | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.total.headers.click')">{{ number_format(props.item.click) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.total.headers.cpc')">{{ props.item.cpc | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.total.headers.ctr')">{{ props.item.ctr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.total.headers.digestiveAmount')">{{ props.item.digestiveAmount | digestive_format }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.total.headers.cv')">{{ number_format(props.item.cv) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.total.headers.cpa')">{{ props.item.cpa | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.total.headers.cvr')">{{ props.item.cvr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.total.headers.vcv')">{{ props.item.vcv | number_format }}</li>
                  <!-- not VideoAds -->
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.playCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.firstQuartileCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.midpointCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.thirdQuartileCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.completeCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.cpcv')"> - </li>
                  <!-- is VideoAds -->
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.playCount')">{{ props.item.videoReport.playCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.firstQuartileCount')">{{ props.item.videoReport.firstQuartileCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.midpointCount')">{{ props.item.videoReport.midpointCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.thirdQuartileCount')">{{ props.item.videoReport.thirdQuartileCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.total.headers.completeCount')">{{ props.item.videoReport.completeCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.total.headers.cpcv')">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify-left class="mt-3">
      <v-col xs12 class="text-right">
        <v-btn color="light-green darken-1 text-white" :disabled="isDisabledCsvDownloadBtn" @click="clickDownload()">
          <v-icon>get_app</v-icon>
          {{ $t('campaignReport.dailyReport.download') }}
        </v-btn>
        <div class="caption text-red-accent-4">{{ $t('campaignReport.dailyReport.infoMessage') }}</div>
      </v-col>
    </v-row>
    <v-row justify-left>
      <v-col xs12>
        <v-data-table
          :headers="dailyReportHeaders"
          :items="infoDailyReport"
          :hide-default-header="isMobile"
          hide-default-footer
          :sort-by="pagination.sortBy"
          :sortDesc="pagination.descending"
          :items-per-page="pagination.rowsPerPage"
          :no-data-text="$t('commons.table.no.data.text')"
          class="elevation-3"
          :class="{ mobile: isMobile }"
          style="white-space: nowrap;"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-center">{{ props.item.day | date_format }}</td>
              <td class="text-right">{{ number_format(props.item.imp) }}</td>
              <td class="text-right">{{ props.item.cpm | number_format_yen_fixed_decimal }}</td>
              <td class="text-right">{{ number_format(props.item.click) }}</td>
              <td class="text-right">{{ props.item.cpc | number_format_yen_fixed_decimal }}  </td>
              <td class="text-right">{{ props.item.ctr | percent_format_cpm }}</td>
              <td class="text-right">{{ props.item.digestiveAmount | digestive_format }}</td>
              <td class="text-right">{{ number_format(props.item.cv) }}</td>
              <td class="text-right">{{ props.item.cpa | number_format_yen_fixed_decimal }}</td>
              <td class="text-right">{{ props.item.cvr | percent_format_cpm }}</td>
              <td class="text-right">{{ props.item.vcv | number_format }}</td>
              <!-- not VideoAds -->
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <td v-if="!isVideoAds(contentsType)" class="text-center"> - </td>
              <!-- is VideoAds -->
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.playCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.firstQuartileCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.midpointCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.thirdQuartileCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.completeCount | number_format }}</td>
              <td v-if="isVideoAds(contentsType)" class="text-right">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</td>
            </tr>
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item word-break" :data-label="$t('campaignReport.dailyReport.headers.day')">{{ props.item.day | date_format }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.imp')">{{ number_format(props.item.imp) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.cpm')">{{ props.item.cpm | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.click')">{{ number_format(props.item.click) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.cpc')">{{ props.item.cpc | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.ctr')">{{ props.item.ctr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.digestiveAmount')">{{ props.item.digestiveAmount | digestive_format }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.cv')">{{ number_format(props.item.cv) }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.cpa')">{{ props.item.cpa | number_format_yen_fixed_decimal }}</li>
                  <li class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.cvr')">{{ props.item.cvr | percent_format_cpm }}</li>
                  <li class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.vcv')">{{ props.item.vcv | number_format }}</li>
                  <!-- not VideoAds -->
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.playCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.firstQuartileCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.midpointCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.thirdQuartileCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.completeCount')"> - </li>
                  <li v-if="!isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.cpcv')"> - </li>
                  <!-- is VideoAds -->
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.playCount')">{{ props.item.videoReport.playCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.firstQuartileCount')">{{ props.item.videoReport.firstQuartileCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.midpointCount')">{{ props.item.videoReport.midpointCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.thirdQuartileCount')">{{ props.item.videoReport.thirdQuartileCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item3" :data-label="$t('campaignReport.dailyReport.headers.completeCount')">{{ props.item.videoReport.completeCount | number_format }}</li>
                  <li v-if="isVideoAds(contentsType)" class="flex-item4" :data-label="$t('campaignReport.dailyReport.headers.cpcv')">{{ props.item.videoReport.cpcv | number_format_yen_fixed_decimal }}</li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify-end>
      <v-col class="text-right memo-text py-1 px-1">ad_{{ advertiserId }} stp_{{ campaignId }}</v-col>
    </v-row>
    <v-dialog v-model="nodataDialog" scrollable max-width="300px">
      <v-card>
        <v-card-title>
          {{ $t('campaignReport.dialog.filedownload.title') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text height="300px">
          {{ $t('campaignReport.dialog.filedownload.nodata') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="nodataDialog = false">
            {{ $t('campaignReport.dialog.filedownload.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment'
import CsvDownload from '../plugins/csvDownload'
export default {
  components: { VueDatePicker },
  name: 'campaignReport',
  props: ['campaignPeriodId'],
  mixins: [CsvDownload],
  data: function () {
    return {
      pagination: {
        sortBy: [{ key: 'day', order:'asc' }],
        descending: false,
        rowsPerPage: -1
      },
      // フィルタ：INPUT
      campaignIds: [],
      creativeSizeIds: [],
      creativeTypeIds: [],
      creativeName: '',
      dateRange: {},
      aggregateDateRange: '',
      // 初期 or 検索ボタンを押した状態を保持する( DL やページングはこの条件を用いる)
      commitedDateRange: {},
      // 画面描画条件
      opens: 'right',
      ranges: {},
      minDate: '',
      maxDate: '',
      campaignList: [],
      infoDailyReport: [],
      contentsType: 0,
      isMobile: false,
      isCampaignAllSelect: false,
      isCreativeTypeAllSelect: false,
      isCreativeSizeAllSelect: false,
      isFromSearch: false,
      isSearching: false,
      nodataDialog: false,
      isDownloadCsv: false,
      isLeftVisible: false,
      isRightVisible: true,
      infoHeaders: [
        {
          title: this.$t('campaignReport.info.headers.advertiserName'),
          align: 'center',
          sortable: false,
          key: 'advertiserName',
          height: '15px'
        },
        {
          title: this.$t('campaignReport.info.headers.campaignName'),
          align: 'center',
          sortable: false,
          key: 'campaignName'
        },
        {
          title: this.$t('campaignReport.info.headers.cpxreportType'),
          align: 'center',
          sortable: false,
          key: 'cpxreportType'
        }
      ],
      infoTotalReport: [],
      totalHeaders: [
        { title: this.$t('campaignReport.total.headers.aggregateDateRange'), align: 'center', sortable: false, key: 'aggregateDateRange', width: '100' },
        { title: this.$t('campaignReport.total.headers.imp'), align: 'center', sortable: false, key: 'imp', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.cpm'), align: 'center', sortable: false, key: 'cpm', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.click'), align: 'center', sortable: false, key: 'click', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.cpc'), align: 'center', sortable: false, key: 'cpc', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.ctr'), align: 'center', sortable: false, key: 'ctr', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.digestiveAmount'), align: 'center', sortable: false, key: 'digestiveAmount', class: 'padding-right text-no-wrap' },
        { title: this.$t('campaignReport.total.headers.cv'), align: 'center', sortable: false, key: 'cv', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.cpa'), align: 'center', sortable: false, key: 'cpa', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.cvr'), align: 'center', sortable: false, key: 'cvr', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.vcv'), align: 'center', sortable: false, key: 'vcv', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.playCount'), align: 'center', sortable: false, key: 'playCount', class: 'padding-right' },
        { title: this.$t('campaignReport.total.headers.firstQuartileCount'), align: 'center', sortable: false, key: 'firstQuartileCount', class: 'padding-right text-no-wrap' },
        { title: this.$t('campaignReport.total.headers.midpointCount'), align: 'center', sortable: false, key: 'midpointCount', class: 'padding-right text-no-wrap' },
        { title: this.$t('campaignReport.total.headers.thirdQuartileCount'), align: 'center', sortable: false, key: 'thirdQuartileCount', class: 'padding-right text-no-wrap' },
        { title: this.$t('campaignReport.total.headers.completeCount'), align: 'center', sortable: false, key: 'completeCount', class: 'padding-right text-no-wrap' },
        { title: this.$t('campaignReport.total.headers.cpcv'), align: 'center', sortable: false, key: 'cpcv', class: 'padding-right' }
      ],
      infoResult: [],
      dailyReportHeaders: [
        { title: this.$t('campaignReport.dailyReport.headers.day'), align: 'center', sortable: true, key: 'day' },
        { title: this.$t('campaignReport.dailyReport.headers.imp'), align: 'center', sortable: true, key: 'imp' },
        { title: this.$t('campaignReport.dailyReport.headers.cpm'), align: 'center', sortable: true, key: 'cpm' },
        { title: this.$t('campaignReport.dailyReport.headers.click'), align: 'center', sortable: true, key: 'click' },
        { title: this.$t('campaignReport.dailyReport.headers.cpc'), align: 'center', sortable: true, key: 'cpc' },
        { title: this.$t('campaignReport.dailyReport.headers.ctr'), align: 'center', sortable: true, key: 'ctr' },
        { title: this.$t('campaignReport.dailyReport.headers.digestiveAmount'), align: 'center', sortable: true, key: 'digestiveAmount' },
        { title: this.$t('campaignReport.dailyReport.headers.cv'), align: 'center', sortable: true, key: 'cv' },
        { title: this.$t('campaignReport.dailyReport.headers.cpa'), align: 'center', sortable: true, key: 'cpa' },
        { title: this.$t('campaignReport.dailyReport.headers.cvr'), align: 'center', sortable: true, key: 'cvr' },
        { title: this.$t('campaignReport.dailyReport.headers.vcv'), align: 'center', sortable: true, key: 'vcv' },
        { title: this.$t('campaignReport.dailyReport.headers.playCount'), align: 'center', sortable: true, key: 'playCount' },
        { title: this.$t('campaignReport.dailyReport.headers.firstQuartileCount'), align: 'center', sortable: true, key: 'firstQuartileCount' },
        { title: this.$t('campaignReport.dailyReport.headers.midpointCount'), align: 'center', sortable: true, key: 'midpointCount' },
        { title: this.$t('campaignReport.dailyReport.headers.thirdQuartileCount'), align: 'center', sortable: true, key: 'thirdQuartileCount' },
        { title: this.$t('campaignReport.dailyReport.headers.completeCount'), align: 'center', sortable: true, key: 'completeCount' },
        { title: this.$t('campaignReport.dailyReport.headers.cpcv'), align: 'center', sortable: true, key: 'cpcv' }
      ],
      errorMessage: undefined
    }
  },
  methods: {
    ...mapActions('campaignReport', ['getCampaignReport']),
    initialize: function () {
      this.previewCampaignReport()
      this.initializeDateTimeRanges()
    },
    initializeDateTimeRanges: function () {
      // 今日
      const today = moment().startOf('day').toDate()
      // 昨日
      const yesterday = moment(today).add(-1, 'days').startOf('day').toDate()
      // 当日から一週間前
      const lastWeekAgo = moment(today).add(-6, 'days').toDate()
      // 昨日から一週間前
      const lastWeekDayAgo = moment(yesterday).add(-6, 'days').toDate()
      // 月初
      const monthFirst = moment(today).startOf('month').toDate()
      // 先月末
      const lastMonthEnd = moment(today).startOf('month').add(-1, 'days').toDate()
      // 先月月初
      const lastMonthFirst = moment(lastMonthEnd).startOf('month').toDate()
      // 30日前
      const day30ago = moment(today).add(-29, 'days').toDate()
      // 半年前（厳密な半年ではないが、代理店画面と合わせた）
      const halfYearDay = moment(today).add(-6, 'month').add(1, 'days').toDate()
      this.ranges = {
        [this.$t('commons.filter.calendar.today')]: [today, today],
        [this.$t('commons.filter.calendar.yesterday')]: [yesterday, yesterday],
        [this.$t('commons.filter.calendar.lastWeekAgo')]: [lastWeekAgo, today],
        [this.$t('commons.filter.calendar.lastWeekDayAgo')]: [lastWeekDayAgo, yesterday],
        [this.$t('commons.filter.calendar.day30ago')]: [day30ago, today],
        [this.$t('commons.filter.calendar.halfYearDay')]: [halfYearDay, today],
        [this.$t('commons.filter.calendar.thisMonth')]: [monthFirst, today],
        [this.$t('commons.filter.calendar.thisMonthYesterday')]: [monthFirst, yesterday],
        [this.$t('commons.filter.calendar.lastMonth')]: [lastMonthFirst, lastMonthEnd]
      }
      this.maxDate = today
      // 代理店画面と合わせて半年前の1日まで選択可能とした
      this.minDate = moment(halfYearDay).startOf('month').toDate()
      // 初期選択（引数がなければ当月とする）
      let startDate = this.$route.query.from ? moment(this.$route.query.from, 'YYYYMMDD').toDate() : monthFirst
      let endDate = this.$route.query.to ? moment(this.$route.query.to, 'YYYYMMDD').toDate() : today
      this.dateRange = { startDate: startDate, endDate: endDate }
      this.commitedDateRange = { startDate: startDate, endDate: endDate }
    },
    previewCampaignReport: async function () {
      this.isSearching = true
      this.isCsvDownload = false

      const jwtToken = this.$store.getters['auth/jwtToken']
      await this.getCampaignReport({
        privateCode: this.$attrs.privateCode,
        advertiserId: this.advertiserId,
        agencyId: this.agencyId,
        campaignId: this.campaignId,
        targetDateFrom: this.$route.query.from,
        targetDateTo: this.$route.query.to,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.infoResult = []
            this.infoTotalReport = []
            this.infoDailyReport = []
            this.isCsvDownload = false
            return
          }
          this.aggregateDateRange = moment(this.$route.query.from).format('YYYY/MM/DD') + ' - ' + moment(this.$route.query.to).format('YYYY/MM/DD')
          this.infoResult = [result]
          this.infoTotalReport = [result.totalReport]
          this.infoDailyReport = result.dailyReport
          this.contentsType = result.campaign.contentsType
          const elements = document.getElementsByClassName('padding-right')
          Array.from(elements).forEach(function (el) {
            el.setAttribute('style', 'padding-right:35px;')
          })
          if (this.infoDailyReport.length > 0) {
            this.isCsvDownload = true
          }
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
        .then(() => {
          this.isSearching = false
        })
    },
    search: function () {
      this.isFromSearch = true
      this.commitedDateRange = this.dateRange
      this.$route.query.from = this.formatParameterDate(this.commitedDateRange.startDate)
      this.$route.query.to = this.formatParameterDate(this.commitedDateRange.endDate)
      this.previewCampaignReport()
    },
    clickDownload: function () {
      this.isDownloadCsv = true
      const dailyReport = this.$store.getters['campaignReport/dailyReport']
      if (!dailyReport || dailyReport.length <= 0) {
        this.nodataDialog = true
        this.isDownloadCsv = false
        return
      }
      let csvList = []
      this.createCsvHeader(csvList)
      csvList = this.createCsvLines(csvList, dailyReport)
      this.csvDownload(csvList, 'campaign_report', [this.advertiserId, this.campaignPeriodId])
      this.isDownloadCsv = false
    },
    createCsvHeader: function(csvList) {
      csvList.push(
        this.$t('campaignReport.dailyReport.headers.day') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.imp') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cpm') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.click') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cpc') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.ctr') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.digestiveAmount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cv') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cpa') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cvr') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.vcv') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.playCount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.firstQuartileCount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.midpointCount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.thirdQuartileCount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.completeCount') +
        ',' +
        this.$t('campaignReport.dailyReport.headers.cpcv')
      )
      return csvList
    },
    createCsvLines: function(csvList, dailyReport) {
      dailyReport.forEach((el) => {
        const line = this.createCsvLineElement(el)
        csvList.push(line)
      })
      return csvList
    },
    createCsvLineElement: function(element) {
      const day = moment(`${element['day']}`).format('YYYY/MM/DD')
      const campaignElement = this.formatCampaignElement(element)
      // VideoReport 情報がない時は、Nullの代わりに空欄を入れる
      let videoElement = []
      if (element.videoReport !== null) {
        videoElement.push(element.videoReport.playCount !== null ? element.videoReport.playCount : '')
        videoElement.push(element.videoReport.firstQuartileCount !== null ? element.videoReport.firstQuartileCount : '')
        videoElement.push(element.videoReport.midpointCount !== null ? element.videoReport.midpointCount : '')
        videoElement.push(element.videoReport.thirdQuartileCount !== null ? element.videoReport.thirdQuartileCount : '')
        videoElement.push(element.videoReport.completeCount !== null ? element.videoReport.completeCount : '')
        videoElement.push(element.videoReport.cpcv !== null ? parseFloat(element.videoReport.cpcv).toFixed(6) : '')
      }
      videoElement.join()

      return day + campaignElement + videoElement
    },
    clickCreativeReport: function () {
      this.$router.push({
        path: `/cpmCreativeReportList/${this.agencyId}/${this.advertiserId}`,
        query: {
          cIds: this.infoResult[0]['campaign']['campaignId'],
          from: this.formatParameterDate(this.infoResult[0]['targetDateFrom']),
          to: this.formatParameterDate(this.infoResult[0]['targetDateTo'])
        }
      })
    },
    // CSV ダウンロードのためのフォマット
    formatCampaignElement: function(element) {
      let result = []
      Object.keys(element).forEach(key => {
        switch (key) {
          case 'cpm':
            result.cpm = element['cpm'] !== null ? parseFloat(element['cpm']).toFixed(6) : ''
            break
          case 'cpc':
            result.cpc = element['cpc'] !== null ? parseFloat(element['cpc']).toFixed(6) : ''
            break
          case 'ctr':
            result.ctr = element['ctr'] !== null ? parseFloat(element['ctr']).toFixed(6) : ''
            break
          case 'cpa':
            result.cpa = element['cpa'] !== null ? parseFloat(element['cpa']).toFixed(6) : ''
            break
          case 'cvr':
            result.cvr = element['cvr'] !== null ? parseFloat(element['cvr']).toFixed(6) : ''
            break
          case 'digestiveAmount':
            result.digestiveAmount = element['digestiveAmount'] !== null ? parseFloat(element['digestiveAmount']).toFixed(6) : ''
            break
          case 'imp':
            result.imp = element['imp'] !== null ? element['imp'] : ''
            break
          case 'click':
            result.click = element['click'] !== null ? element['click'] : ''
            break
          case 'cv':
            result.cv = element['cv'] !== null ? element['cv'] : ''
            break
          case 'vcv':
            result.vcv = element['vcv'] !== null ? element['vcv'] : ''
            break
          default:
            break
        }
      })
      var campaignElement = `,${result['imp']},${result['cpm']},${result['click']},${result['cpc']},${result['ctr']},${result['digestiveAmount']},${result['cv']},${result['cpa']},${result['cvr']},${result['vcv']},`
      return campaignElement
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        const elements = document.getElementsByClassName('padding-right')
        Array.from(elements).forEach(function (el) {
          el.setAttribute('style', 'padding-right:35px;')
        })
        this.isMobile = false
      }
    },
    formatDisplayDate(value) {
      return this.formatDate(value, 'YYYY/MM/DD')
    },
    formatParameterDate(value) {
      return this.formatDate(value, 'YYYYMMDD')
    },
    formatDate(value, format) {
      return moment(value).format(format)
    },
    isVideoAds: function (contentsType) {
      if (contentsType === 2) {
        return true
      }
      return false
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    this.initialize()
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = []
      if (this) {
        breadcrumbs.push({
          title: this.$t('commons.breadcrumbs.campaignList'),
          disabled: false,
          to: { path: `/campaignList/${this.agencyId}/${this.advertiserId}` }
        })
        breadcrumbs.push({
          title: this.$t('commons.breadcrumbs.campaignReport'),
          disabled: true
        })
      }
      return breadcrumbs
    },
    advertiserId: function () {
      if (!this.$attrs) {
        return undefined
      }
      return this.$attrs.advertiserId
    },
    agencyId: function () {
      if (!this.$attrs) {
        return undefined
      }
      return this.$attrs.agencyId
    },
    campaignId: function () {
      if (!this.$attrs) {
        return undefined
      }
      return this.$attrs.campaignId
    },
    isDisabledBtn: function () {
      if (this.isSearching) {
        return true
      }
      return false
    },
    isDisabledCsvDownloadBtn: function () {
      if (this.isDisabledBtn) {
        return true
      }
      if (!this.isCsvDownload) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
.memo-text {
  font-size: 10px;
}
.v-label {
  font-size: 12px !important;
}
</style>
